/**
 * Upload Configuration Constants
 * 
 * Defines thresholds and settings for the hybrid upload system.
 * Files above TUS_THRESHOLD use resumable TUS uploads for reliability.
 * Files below use standard uploads with XHR progress tracking.
 */

/** Files larger than 50MB use TUS resumable upload protocol */
export const TUS_THRESHOLD = 50 * 1024 * 1024; // 50MB

/** Chunk size for TUS uploads (Supabase recommended) */
export const TUS_CHUNK_SIZE = 6 * 1024 * 1024; // 6MB

/** Retry delays for failed TUS uploads (exponential backoff) */
export const TUS_RETRY_DELAYS = [0, 3000, 5000, 10000, 20000];

/** Supabase URL from environment variable */
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
if (!supabaseUrl) {
  console.error('VITE_SUPABASE_URL environment variable is not set. File uploads will fail.');
}
export const SUPABASE_URL = supabaseUrl || '';

/** TUS upload endpoint for Supabase Storage */
export const TUS_ENDPOINT = `${SUPABASE_URL}/storage/v1/upload/resumable`;
